//Core
import {useNavigate} from "react-router-dom";
import {useState} from "react";
//Hooks
import {usePathname} from "@/utils/hooks/usePathname";

export const useMobileHeader = () => {
    const { isHomepage, isLoginPage } = usePathname();
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => setMenuOpen(!menuOpen);
    return {
        isHomepage,
        isLoginPage,
        goToHomepage: () => navigate("/"),
        menuOpen,
        toggleMenu,
        headerClass: isHomepage ? "home" : "",
        logoColor: isHomepage ? "#FFFFFF" : "#0B0A1A",
    }
}